<template>
  <dashboard-template>
    <template slot="dashboard-header">
      <div class="d-flex justify-content-between w-100">
        <h6 class="mb-0">{{ $t('sources.source_details') }}</h6>
        <img class="tooltip-icon icon-small ml-3" id="tooltip-source-show" v-bind:src="'/app/images/icons/info.svg'" />
        <b-popover target="tooltip-source-show" variant="warning" triggers="hover" placement="bottom">
          <div v-html="$t('tooltips.source_show')"></div>
        </b-popover>
      </div>
    </template>
    <template slot="dashboard-body">
      <div class="dashboard-content" v-if="!isLoading">
        <div v-if="products !== undefined">
          <div class="d-flex justify-content-between my-4">
            <div class="d-flex align-items-center mb-4">
              <img class="icon" v-bind:src="'/app/images/icons/sources/'+source.config.fileType+'.svg'" />
              <h5>{{ source.name }}</h5>
            </div>
          </div>
          <div class="d-flex align-items-center my-4">
            <strong class="mr-4">{{$t('sources.main_id')}}</strong>
            <multiselect
              @select="onProductPropertySelect"
              class="source-preview-multiselect"
              label="propertyLabel"
              track-by="propertyName"
              v-model="selectedProductProperty"
              :allow-empty="false"
              :deselect-label="''"
              :multiple="false"
              :options="productSource.properties"
              :placeholder="$t('feeds.choose_variable')"
              :searchable="true"
              :select-label="''"
              :selected-label="''">
              <span slot="noResult">{{ $t('global.multiselect_search_not_found') }}</span>
            </multiselect>
            <div v-if="!isSubmitted">
              <button class="btn btn-medium btn-orange-dark mx-4" @click="addProjectSource" :disabled="!isMainProductIdSelected">
                <save-icon></save-icon>
                <span>{{$t('global.save')}}</span>
              </button>
            </div>
            <div v-else class="button-loading-spinner source-preview-button-loading">
              <div class="spinner-border text-orange" role="status"></div>
            </div>
          </div>
          <table class="table table-striped table-bordered">
            <thead class="thead-light">
              <th v-for="(value, key) in productSource.properties" v-bind:key="key">
                {{ value.propertyLabel }}
              </th>
            </thead>
            <tbody>
              <tr v-for="(product, index) in products" v-bind:key="index">
                <td v-for="(product_value, product_key) in productSource.properties" v-bind:key="product_key">
                  <p class="break-text">{{ product[product_value.propertyName] }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="alert alert-danger mb-4 mt-3" role="alert">
            {{ $t('products.products_retrieve_error_wrong_config') }}
          </div>
          <router-link :to="{ name: 'source.create', params: { projectId: this.$route.params.projectId }}" class="mr-2">
            <button type="button" class="btn btn-large btn-orange-dark">
              <plus-circle-icon></plus-circle-icon>
              <span>{{$t('global.try_again')}}</span>
            </button>
          </router-link>
        </div>
      </div>
      <div v-else>
        <div class="spinner-border text-orange" role="status"></div>
      </div>
    </template>
  </dashboard-template>
</template>

<script>
import DashboardTemplate from '@/views/Dashboard'
import Multiselect from 'vue-multiselect'
import products from '@/mixins/products'
import axios from 'axios'
import { PlusCircleIcon, SaveIcon } from 'vue-feather-icons'

export default {
  name: 'SourcePreview',

  data () {
    return {
      isLoading: true,
      isMainProductIdSelected: false,
      isSubmitted: false,
      productSource: {},
      products: this.sourceData.products,
      selectedProductProperty: null,
      source: this.sourceData.source
    }
  },

  props: {
    sourceData: { required: true, type: Object }
  },

  mixins: [products],

  created () {
    if (this.products !== undefined) this.productSource = this.getProductSources(this.products[0])[0]
    this.isLoading = false
  },

  methods: {
    onProductPropertySelect () {
      this.isMainProductIdSelected = true
    },

    addProjectSource () {
      this.isSubmitted = true

      const sourceConfig = {
        name: this.source.name,
        active: this.source.active,
        description: '',
        config: {
          fileType: this.source.config.fileType,
          idPropertyName: this.selectedProductProperty.propertyName,
          primary: this.source.config.primary,
          url: this.source.config.url
        }
      }

      if (this.source.config.analyticsConfig !== undefined) sourceConfig.config.analyticsConfig = this.source.config.analyticsConfig
      if (this.source.config.ftpConfig !== undefined) sourceConfig.config.ftpConfig = this.source.config.ftpConfig
      if (this.source.config.docsConfig !== undefined) sourceConfig.config.docsConfig = this.source.config.docsConfig
      if (this.source.config.xmlConfig !== undefined) sourceConfig.config.xmlConfig = this.source.config.xmlConfig

      axios.post(process.env.VUE_APP_API_ENDPOINT + '/data/sources/add/' + this.$route.params.projectId, sourceConfig)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.$router.push({ name: 'sources', params: { id: this.$route.params.projectId } })
            this.$attrs.project.sources.push(response.data)
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    }
  },

  components: { DashboardTemplate, Multiselect, PlusCircleIcon, SaveIcon }
}
</script>
